import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Setting } from 'src/app/models/MembershipSetting/setting';

import { environment } from 'src/environments/environment';
import { AdhesionService } from '../adhesion/adhesion.service';
import { ErrorService } from '../error/error.service';
import { LoaderService } from '../loader/loader.service';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  private readonly STORAGE_KEY = 'membership_settings';
  private settingsCache: Setting[] | null = null;

  constructor(private http: HttpClient) {}

  async getSettings(forceRefresh = false): Promise<Setting[]> {

    if (this.settingsCache && !forceRefresh) {
      return this.settingsCache;
    }
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored && !forceRefresh) {
      this.settingsCache = JSON.parse(stored);
      return this.settingsCache;
    }

    const settings = await this.http
      .get<Setting[]>(`${environment.baseUrl}/api/MembershipSettings`)
      .toPromise();

    this.settingsCache = settings;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(settings));

    return settings;
  }

  clearCache(): void {
    this.settingsCache = null;
    localStorage.removeItem(this.STORAGE_KEY);
  }
}

